export const FirebaseConfig = {
	"projectId": "taxi-vtc-poniente",
	"appId": "1:187557028553:web:75dee52e3890f8a1db2318",
	"databaseURL": "https://taxi-vtc-poniente-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "taxi-vtc-poniente.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyC5ZUw0EK6lqyHkw4KB4mCug8xpNV4Nj3M",
	"authDomain": "taxi-vtc-poniente.firebaseapp.com",
	"messagingSenderId": "187557028553",
	"measurementId": "G-GPCSZJN358"
};